//本地存储存取方法
import {saveToLocal, loadFromLocal} from "common/js/store"
import {getUserLoginStatus} from "./getters";

const mutations = {
  //刷入用户信息
  updateUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  updatePhotourl (state, url) {
    state.photoUrl = url
  },
  updateUsername(state, n) {
    let strn = n.toString();
    state.username = state.username + strn;
  },
  updateNickname(state, n) {
    state.nickname = n;
  },
  //切换皮肤
  changeSkinId(state, n) {
    state.skinSign = n;
    let username
    if (!state.userInfo.loginName) {
      username = 'anon'
    } else {
      username = state.userInfo.username
    }
    saveToLocal("config", username + "skinSign", n);
  },

  //切换loading显示状态
  updateLoadingStatus(state, n) {
    state.isShowLoading = n;
  },


  //切换右侧栏菜单显示
  toggleSideMenuShow(state, n) {
    state.isShowSideMenu = n;
  },
  //切换用户头像显示
  toggleTopAvatarShow(state, n) {
    state.isShowTopAvatar = n;
  },
  //更新通知公告列表
  updateNoticeList(state, data) {
    state.noticeList = data;
  },
  //更新系统列表
  updateSystemList(state, data) {
    if (data) {
      data.unshift({appid: null, name: '全部'});
    }
    state.systemList = data;
    state.systemList.push({appid: 'ehall', name: '一站式微服务平台'})
  },
  //更新小工具数据
  updateToolsList(state, dataArr) {
    dataArr.forEach((item, index) => {
      state.toolsList.push(item);
    })
  },
  //更新资料确认情况
  updateProfileBaseConfirmState(state, confirmState) {
    state.profileBaseConfirmState = confirmState
  },
  updateProfileExtraConfirmState(state, confirmState) {
    state.profileExtraConfirmState = confirmState
  },
  //更新模态框层级
  updateModalZIndex(state, dom) {
    state.modalZIndex += 1
    dom.style.zIndex = state.modalZIndex
  },
  //动态改变层级
  updateDynamicModalZIndex(state, dom) {
    state.modalZIndex += 1
    dom.parentNode.parentNode.style.zIndex = state.modalZIndex
  },
  updateEmptyListNotice(state, data) {
    state.noticeEmptyListNotice = data
  },
  //更新邮箱验证状态
  updateEmailVerifyState(state, data) {
    if (!state.userInfo) {
      return
    }
    state.userInfo.confirm_email = data
  },
  //更新密码修改状态
  updatePasswordChangeState(state, data) {
    if (!state.userInfo) {
      return
    }
    state.userInfo.modify_pwd = data
  },
  //更新重要性级别数据
  updateImportanceData(state, data) {
    state.importanceData = data
  },
  //更新微应用列表
  updateMicroProgramList(state, data) {
    state.microProgramList = data
  },
  //更新待办类别
  updateTodoCategory(state, data){
    state.todoCategory = data
  },
  //更新待办部门
  updateTodoDept(state, data){
    state.todoDept = data
  },

};
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js